<template>
  <div class="view-toggle">
    <button 
      @click="setView('list')"
      :class="['toggle-btn', { active: currentView === 'list' }]"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="8" y1="6" x2="21" y2="6"/>
        <line x1="8" y1="12" x2="21" y2="12"/>
        <line x1="8" y1="18" x2="21" y2="18"/>
        <line x1="3" y1="6" x2="3.01" y2="6"/>
        <line x1="3" y1="12" x2="3.01" y2="12"/>
        <line x1="3" y1="18" x2="3.01" y2="18"/>
      </svg>
      <span>List</span>
    </button>
    
    <button 
      @click="setView('map')"
      :class="['toggle-btn', { active: currentView === 'map' }]"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2"/>
        <line x1="8" y1="2" x2="8" y2="18"/>
        <line x1="16" y1="6" x2="16" y2="22"/>
      </svg>
      <span>Map</span>
    </button>
  </div>
</template>

<script setup>
// Props
const props = defineProps({
  modelValue: {
    type: String,
    default: 'list',
    validator: (value) => ['list', 'map'].includes(value)
  }
})

// Emits
const emit = defineEmits(['update:modelValue', 'view-changed'])

// Computed
const currentView = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
    emit('view-changed', value)
  }
})

// Methods
const setView = (view) => {
  currentView.value = view
}
</script>

<style scoped lang="scss">
.view-toggle {
  display: flex;
  border: 1px solid var(--light-grey-border);
  border-radius: 8px;
  overflow: hidden;
  background: var(--white);
}

.toggle-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: var(--dark-grey);
  transition: all 0.2s ease;
  position: relative;

  &:first-child {
    border-right: 1px solid var(--light-grey-border);
  }

  &:hover {
    background: var(--light-grey);
    color: var(--black);
  }

  &.active {
    background: var(--blue);
    color: #fff;

    svg {
      color: #fff;
    }
  }

  svg {
    color: currentColor;
    flex-shrink: 0;
  }

  span {
    white-space: nowrap;
  }

  @media screen and (max-width: 480px) {
    padding: 6px 10px;
    font-size: 12px;
    
    span {
      display: none;
    }
  }
}
</style>